import ro from './ro';

// For now, we only support Romanian
// This can be expanded to support multiple languages in the future
export const translations = {
  ro,
};

export const defaultLanguage = 'ro';

// Helper function to get translation
export const t = (key, params = {}) => {
  const keys = key.split('.');
  let value = translations[defaultLanguage];
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
  }
  
  // Replace parameters like {amount} with actual values
  if (typeof value === 'string' && Object.keys(params).length > 0) {
    return Object.entries(params).reduce((str, [param, val]) => {
      return str.replace(new RegExp(`\\{${param}\\}`, 'g'), val);
    }, value);
  }
  
  return value;
};

export default t;
